<template>
    <div>
        <b-form-group :label="label" :label-for="id">
            <b-form-input :id="id" :value="value" :readonly="readonly"></b-form-input>
        </b-form-group>
    </div>
</template>

<script>
    import mobiscroll from '@mobiscroll/javascript'
    import axios from 'axios'
    import _ from 'lodash'

    export default {

        props: {
            placeholder: {
                type: String,
                default: ''
            },
            readonly: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                default: '[Label]'
            },
            origin: {
                type: String,
                default: null
            },
            value: {
                default: null
            }
        },

        computed: {
            selectedQuery(){
                return axios.defaults.baseURL + '/' + this.origin + '/'
            },
        },

        methods: {
            loadValues(){
                axios.post(this.origin, {value: this.value, fullData: this.fullData}).then(r => {
                    this.inst.option({data: r.data})
                    this.availableOptions = r.data
                    this.inst.setVal(this.value)
                })
            },

            updateOptions(){
                this.inst.clear()
                this.initialize()
            },
            initialize(){
                this.inst = mobiscroll.select('#' + this.id, {
                    display: 'bubble',
                    filter: true,
                    readonly: this.readonly,
                    placeholder: this.placeholder,
                    inputClass: 'form-control',
                    data: {
                        url: this.selectedQuery,
                        remoteFilter: false,
                        type: 'json',
                        processResponse: (response) => {
                            this.availableOptions = response.data
                            return response.data
                        }
                    },
                    onSet:(event, inst) => {
                        this.$emit('input', inst.getVal())
                    }
                })
                this.loadValues()
            }
        },

        data: () => {
            return {
                id: null,
                dependingStatus: null,
                dependsOn: null,
                inst: null,
                availableOptions: []
            }
        },

        beforeMount(){
            this.id = _.uniqueId('select-id')
        },

        mounted(){
            this.initialize()
        },

        watch: {
            readonly(){
                console.log("Setting options", this.readonly, this.inst.option)
                if(typeof this.inst == 'object' && typeof this.inst.option == 'function')
                    this.inst.option({readonly: this.readonly})
            }
        }
    }
</script>